import React from 'react';
import {Image, Row, Col} from 'react-bootstrap';
import Helmet from "react-helmet";
import { Link } from 'react-router-dom';

import img1 from '../../assets/images/contents/ccis.png';

export const Proceeding = () => (
  <div>
  <Helmet>
    <title>The 6th International Conference on Soft Computing in Data Science 2021 (SCDS2021) - Proceeding</title>
    <meta name="description" content="The SCDS2015, SCDS2016, SCDS2017, SCDS2018 and SCDS2019 proceedings were published in the Communications 
      in Computer and Information Science series which is abstracted (indexed) by DBLP, EI, and Scopus." />
    <meta name="keywords" content="proceeding, scds 2021, uitm, aaec, shah alam, conference" />
  </Helmet>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><Link to="/scds2021/home">Home</Link></li>
        <li class="breadcrumb-item active" aria-current="page">Proceeding</li>
      </ol>
    </nav>

    <h2>Proceeding</h2>
     
     <p style={{ textAlign:'justify'}}>
      Congratulations! Your paper submitted to SCSD2021 is published in Springer CCIS series. Please click on link below to access the papers:<br/>
      <a href="https://link.springer.com/book/10.1007/978-981-16-7334-4" >
        https://link.springer.com/book/10.1007/978-981-16-7334-4
      </a>
    </p>

    <Row>
      <Col>                                              
        <Image src={img1}/>   
      </Col>                     
    </Row>

    <br/> 

    <p style={{ textAlign:'justify'}}>
      The SCDS2015, SCDS2016, SCDS2017 and SCDS2018 proceedings were published in the Communications in Computer and Information Science series which is abstracted (indexed) 
      by DBLP, EI, Scopus and were submitted for the inclusion in ISI Proceedings.
    </p>

  </div>
)